<header class="p-3 mb-3 border-bottom">
  <div class="container">
    <div class="d-flex flex-wrap align-items-center justify-content-center justify-content-lg-start">
      <a href="/" class="d-flex align-items-center mb-2 mb-lg-0 px-2 text-dark text-decoration-none">
        <img class="bi me-2" src="assets/logo_main_small.png">
      </a>

      <ul ngbNav #nav="ngbNav" [(activeId)]="active" class="nav-pills">
        <li [ngbNavItem]="1"><a ngbNavLink [routerLink]="'/'"  routerLinkActive="active" class="nav-link px-2 link-secondary">Dashboard</a></li>
        <li [ngbNavItem]="2"><a ngbNavLink [routerLink]="'/job/list'"  routerLinkActive=""  class="nav-link px-2 link-dark">Jobs</a></li>
        <li [ngbNavItem]="3"><a ngbNavLink [routerLink]="'/import-list'"  routerLinkActive=""  class="nav-link px-2 link-dark">Imports</a></li>
        <li [ngbNavItem]="4"><a ngbNavLink [routerLink]="'/report-list'"  routerLinkActive=""  class="nav-link px-2 link-dark">Reporting</a></li>
        <li [ngbNavItem]="5"><a ngbNavLink [routerLink]="'/schedule-view'"  routerLinkActive=""  class="nav-link px-2 link-dark">Schedule</a></li>
      </ul>

      <form class="col-12 col-lg-auto mb-3 mb-lg-0 me-lg-3">
        <input type="search" class="form-control" placeholder="Search...">
      </form>

      <div class="nav-item" ngbDropdown>
        <a class="nav-link" tabindex="0" ngbDropdownToggle id="navbarDropdown1">
          <img src="https://github.com/mdo.png" alt="mdo" width="32" height="32" class="rounded-circle">
        </a>
        <div ngbDropdownMenu aria-labelledby="navbarDropdown1" class="dropdown-menu">
          <a class="dropdown-item" href="#">Profile</a>
          <hr class="dropdown-divider">
          <a class="dropdown-item" [routerLink]="" (click)="logout()">Sign out</a>
          <hr class="dropdown-divider">
          <a class="dropdown-item" [routerLink]="'/change-password'">Change Password</a>
        </div>
      </div>
    </div>
  </div>
</header>

<main role="main" class="container">
  <router-outlet></router-outlet>
</main>


